import { Component, input } from '@angular/core';
import { ComponentSharedModule } from '@app/modules/component.shared.module';
import { ParagraphPgPnav } from '@app/models/paragraph.model';
import { MediaComponent } from '@app/components/media/media.component';
import { Media } from '@app/models/media.model';
import { HeroTextComponent } from '@app/components/hero-text/hero-text.component';
import { Icon, Url } from '@app/models/global.model';

@Component({
  selector: 'mobi-hero-v-images',
  standalone: true,
  imports: [ComponentSharedModule, HeroTextComponent, MediaComponent],
  templateUrl: './hero-v-images.component.html',
  styleUrls: ['./hero-v-images.component.scss'],
})
export class HeroVImagesComponent {
  readonly superTitle = input<string | undefined>();
  readonly subtitle = input<string | undefined>();
  readonly title = input.required<string>();
  readonly lead = input<string | undefined>();
  readonly contentLinks = input<ParagraphPgPnav[] | undefined>();
  readonly headerImages = input<ReadonlyArray<Media>>();
  readonly primaryCta = input<Url | undefined>();
  readonly primaryCtaIcon = input<Icon | undefined>();
  readonly secondaryCta = input<Url | undefined>();
  readonly secondaryCtaIcon = input<Icon | undefined>();
}
